import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './modules/alert';
import { user } from './modules/user';
import { creator } from './modules/creator';
import { file } from './modules/file';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    alert,
    creator,
    file
  },
  state: {
    history: [],
  },
  getters: {
  },
  mutations: {
  },
})
